import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from "react-redux";
import styled from "styled-components";
// noinspection ES6CheckImport
import {
    useAsyncDebounce,
    useExpanded,
    useFilters,
    useFlexLayout,
    useGlobalFilter,
    useSortBy,
    useTable
} from "react-table";
import { Col, Row, Button, Table, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import InputDate from './InputDate'
import { matchSorter } from 'match-sorter'
import {
    Black,
    Shadow,
    StripedRowColor,
    WerfenColor,
    WerfenSecondaryColor,
    WerfenColor2,
    WerfenColor3,
    White
} from "../../../../Constants/ColorChart";
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";
import SquarePlusIcon from '../../../Icons/SquarePlus/SquarePlus';
import SquareMinusIcon from '../../../Icons/SquareMinus/SquareMinus';
import DeleteIcon from '../../../Icons/Trash/Trash';
import TicketModal from "./TicketModal";
import './TicketSection.css';
import { bindActionCreators } from "redux";
import {
    removeTicketFromList,
    setStatusFilters,
    setTicketList,
    setTicketType,
    showTicketModal
} from "../../../../../actions/tickets";
import { formatDate } from "../../../../../../web/Utils/utils";
import 'date-input-polyfill-react';
import Loader from "../../../Loader/Loader";
import { BackendURL } from "../../../../Constants/AppData";
import TicketForm from "../../../TicketForm/TicketForm";
import ConfirmationDialog from "./ConfirmationModal";


const ActionsWrapper = styled.div`
    margin-bottom: 18px;
`

const ActionsGrid = styled ( ToggleButtonGroup )` 
    
    .button {
        border-radius: 0;
        margin-right: 24px;
        outline:0;
    }
    
    .button__primary {
        background: ${ WerfenColor };
        color: ${ White };
        border-color: ${ WerfenColor };
        outline:0;
        &:hover,
        &:focus{
            background: ${ WerfenColor }!important;
            color: ${ White };
            border-color: ${ WerfenColor };
            outline:0;
            box-shadow: unset;
        }
        &:active, 
        &:active:hover {
            background: ${ WerfenColor2 }!important;
            color: ${ White };
            border-color: ${ WerfenColor };
            outline:0;
            box-shadow: unset;
        }
    }
    
    .button__request {
        background: ${ WerfenSecondaryColor };
        color: ${ White };
        border-color: ${ WerfenSecondaryColor };
        outline:0;
        &:hover,
        &:focus{
            background: ${ WerfenSecondaryColor }!important;
            color: ${ White };
            border-color: ${ WerfenSecondaryColor };
            outline:0;
            box-shadow: unset;
        }
        &:active, 
        &:active:hover {
            background: ${ WerfenColor2 }!important;
            color: ${ White };
            border-color: ${ WerfenColor };
            outline:0;
            box-shadow: unset;
        }
    }
    
    .button__secondary {
        background: ${ White };
        color: ${ Black };
        border-color: ${ White };
        outline:0;
        &.active,
        &:focus,
        &:hover {
            outline:0;
            color: ${ White };
            border-color: ${ WerfenColor3 }!important;
            background: ${ WerfenColor3 }!important;
            box-shadow: unset;
        }
        &:active, 
        &:active:hover {
            outline:0;
            color: ${ White };
            border-color: ${ WerfenColor3 }!important;
            background: ${ WerfenColor3 }!important;
            box-shadow: unset;
        }
    }
    label.btn input[type="radio"] {
        visibility: hidden;
        width: 0;
    }
    
`;

const ActionButton = styled ( Button )`
    
    &.button__primary {

        background: ${ WerfenColor };
        border-color: ${ WerfenColor };
        border-radius: 0;
        color: ${ White };
        margin-right: 24px;
        outline:0;
        
        &:hover,
        &:focus{
            background: ${ WerfenColor }!important;
            color: ${ White };
            border-color: ${ WerfenColor };
            outline:0;
            box-shadow: unset;
        }
        &:active, 
        &:active:hover {
            background: ${ WerfenColor2 }!important;
            color: ${ White };
            border-color: ${ WerfenColor };
            outline:0;
            box-shadow: unset;
        }
    }
`

const StyledDiv = styled.div`
  width: calc(100% - 60px);
  margin-right: auto;
  margin-left: 80px;
  @media screen and (min-width: 992px){
    margin-left: 280px; 
    width: calc(100% - 250px);
  }
`;

const WrapperDiv = styled.div`
    width: 100%;
    margin-left: auto; 
    margin-right: auto;
    margin-bottom:3%;
    color: ${ Black };
    padding: 2%;
    border: 2px solid rgba(0, 0, 0, 0.05); 
    background-clip: padding-box;
`;

const Title = styled.p`
  font-size: 30px;
  margin-top: 0px;
  margin-bottom: 1%;
  @media (max-width: 992px){
    font-size: 18px;
  }
`;

const SearchBox = styled.div`
    text-align: right; 
    margin-bottom: 24px;
    label {
      text-align: left;
      color: ${ Black };
      text-transform: uppercase;
      font-weight: 200;
      font-size: 14px;
      letter-spacing: 2px;
    }
    input {
        border-radius: 0!important;
        border-width: 0 0 1px 0;
        border-color: rgba(0,0,0,0.2);
        min-width: 81% !important;
    }
`;


const StatusFiltersBox = styled.div `
    display:flex;
    align-items: center;
    div {
        width: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    };
    p {
        padding: 8px;
        margin-bottom: 0 !important;
    }
    label {
      text-align: left;
      color: ${ Black };
      text-transform: uppercase;
      font-weight: 200;
      font-size: 14px;
      letter-spacing: 2px;
    }
`;


const StatusFilterPill = styled.span `
        display: block;
        color: ${WerfenColor};
        background-color: #fff;
        padding: 8px;
        margin-right: 12px;
        margin-left: 4px;
        border-radius: 12px;
        border: 2px solid #001387;
`;

const StyledTable = styled ( Table )`
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  font-size: 14px !important;

  @media screen and (min-width: 992px){
    font-size: 20px;
  }
  
    .expander .text + span {
      display: none!important;
    }
    
    .expander .text {
        width: 40px;
        display: block;
        flex-grow: unset!important;
    }
    
    .expander .title {
        display: block;
        width: 40px;
        flex-grow: unset;
    }
    
    .expander > div {
        width: 40px!important;
        display: inline-block;
    }
    
    .filter-date-box {
        position: relative;
        width: 90%;
        & input.filter-field {
            width: 100%;
            height: 100%;
        }
    } 
    
    input, select {
        border-radius: 0!important;
        border-width: 0 0 1px 0;
        border-color: rgba(0,0,0,0.2);
    }  
`;

const TableHeader = styled.th`
  text-align: left;
  color: ${ Black };
  text-transform: uppercase;
  font-weight: 200;
  font-size: 14px;
  letter-spacing: 2px;
  height: auto;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: 1200px){
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const HeaderTitle = styled.div`
  margin-left: 0.1vw;
  white-space: nowrap;    
  height: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
  & .title{
    white-space: normal;
    flex-grow: 1;
    align-items: flex-start;
    display: flex;
    flex-shrink: 0;
    & .text {
        flex-grow: 1;
    }
    & .sup{
        flex:1;
        flex-grow:0
    }
    & .sub{
        flex:1;
        flex-grow:0;
    }
  }
  & .filter {
    display: flex;
    padding: 10px 0;
    flex-grow: 0;
    flex-shrink: 0;
    height: 50px;
    & > input {
        width: 100%;
    }
  }
  & .filter--status {
    height: 75px;
    select {
        display: flex;
        position: relative;
        z-index: 1000;
  }
`;

const TableHead = styled.thead`
    .table > & > tr > th {
        vertical-align: top;
        border: none;
    }
    .table > & > tr {
        border-bottom: 1px solid #ddd;
    }
    table> & > tr > th.id {
        width: 20px !important;
    }
   
      table#requesterTable > & > tr > th.subject {
        max-width: 361px !important;
        padding-left: 10px !important;
    }
`;

const TableBody = styled.tbody`
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 500px;
    display: block;
    .table-striped-alt > & > tr.even {
        background: ${ StripedRowColor };
        border-top: 1px solid #ddd;
        & + tr.even{
            border-top: 0px none transparent;
            display: flex;
            & > td {
                flex-grow: 1;
            }
        }
    }
    .table-striped-alt > & > tr.odd{
        background: ${ White };
        border-top: 1px solid #ddd;
        & + tr.odd{
            border-top: 0px none transparent;
            display: flex;
            & > td {
                flex-grow: 1;
            }
        }
    }
    .table-striped-alt > & > tr.clickableRow {
        cursor: pointer;
    }

    .table > & > tr > td {
        border-top: none;    
        display: flex;
        align-items: center;
    }
    
    table#requesterTable > & > tr > td.materialType,  table#requesterTable > & > tr > td.author, table#requesterTable > & > tr > td.status {
        width: 73px !important;
        padding-left: 0.75rem !important;
    }
    
    table#requesterTable > & > tr > td.executorTeam {
        width: 104px !important;
    }
    
    table#requesterTable  >  & > tr > td.requestedDate, table#requesterTable > & > tr > td.necessityDate, table#requesterTable > & > tr >td.dueDate {
        width: 73px !important;
        
    }
    
   table#requesterTable > & > tr > td.expander  {
        width: 34px !important;
        padding-left: 11px !important;
    }

`;

const TicketActions = ( props ) => {
    const [ value, setValue ] = React.useState ( "all" );

    const handleChange = ( data ) => {
        const mine = props.userUUID || window.localStorage.getItem ( 'userUUID' ) //|| "b3661004-00f1-4181-8fcc-a54bfef23d7c";
        const team = props.teamUUID || window.localStorage.getItem ( 'teamUUID' ) //|| "1fa9327a-42df-4b92-b403-4c2b72b4ef5c";
        switch ( data ) {
            case "team":
                props.setTicketType ( { id: "executorTeam", value: team } );
                break;
            case "all":
                props.setTicketType ( {} );
                break;
            case "mine":
            default:
                props.setTicketType ( { id: "assigned", value: mine } );
                break;
        }
        setValue ( data );
    }

    return (
        <ActionsWrapper>
            <ActionsGrid
                type={ "radio" }
                value={ value }
                name={ "actions" }
                onChange={ handleChange }
                className={ "TicketActions" }>
                <ToggleButton value={ "all" } className="button button__secondary">All Tickets</ToggleButton>
                <ToggleButton value={ "mine" } className="button button__secondary">My Tickets</ToggleButton>
                {/*<ToggleButton value={ "team" } className="button button__secondary">My Team's Tickets</ToggleButton>*/ }
            </ActionsGrid>
            <ActionButton className="button button__primary" type={ "button" } onClick={ () => {
                props.showTicketModal ( props.defaultTicketData )
            } }>Create Ticket</ActionButton>
        </ActionsWrapper>
    )
}

const GlobalFilter = ( { preGlobalFilteredRows, globalFilter, setGlobalFilter, statusFilters } ) => {

    const count = preGlobalFilteredRows.length
    const [ value, setValue ] = React.useState ( globalFilter )
    const [ filtersToDisplay, setStatusFiltersToDisplay] = useState([]);
    const onChange = useAsyncDebounce ( value => {
        setGlobalFilter ( value || undefined )
    }, 200 )

    useEffect ( () => {

        setStatusFiltersToDisplay(statusFilters)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusFilters.length] );


    return (
        <Row >
            <Col lg={{span: 7, offset: 5}} style= {{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginBottom: "16px"}}>
                <StatusFiltersBox>
                    <label>Selected status:</label>
                    { filtersToDisplay.length > 0 ? <div >
                        { filtersToDisplay.map((filter, i) => (
                            <StatusFilterPill key={i} >{filter} </StatusFilterPill>
                        )) }
                    </div>: <p >No Status has been selected yet to filter by</p>}
                </StatusFiltersBox>
            </Col>
            <Col lg={{span: 7, offset: 5}}>
                <SearchBox>
                    <label>Search:</label>
                    <input
                        value={ value || "" }
                        onChange={ e => {
                            setValue ( e.target.value );
                            onChange ( e.target.value );
                        } }
                        placeholder={ `${ count } records...` }
                        style={ {
                            height: "35px",
                            fontSize: "15px",
                            minWidth: "50%"
                        } }
                    />
                </SearchBox>
            </Col>

        </Row>
    )
}

const DefaultColumnFilter = ( { column: { filterValue, preFilteredRows, setFilter }, } ) => {
    const count = preFilteredRows.length

    return (
        <input
            value={ filterValue || '' }
            onChange={ e => {
                setFilter ( e.target.value || undefined ) // Set undefined to remove the filter entirely
            } }
            placeholder={ `Search ${ count } records...` }
        />
    )
}

const SelectKVFilter = ( props ) => {
    const { column: { filterValue, preFilteredRows, setFilter, id }, } = props.info


    const options = React.useMemo ( () => {
        // We use a set to avoid duplicates...
        const options = new Set ()
        if ( props.list && props.list.length > 0 ) {
            preFilteredRows.forEach ( row => {
                const optionLabelIndex = props.list.findIndex ( ( itemInList ) => itemInList.id === row.values[id] );
                if ( optionLabelIndex !== -1 ) {
                    const optionLabel = props.list[optionLabelIndex].name
                    // but a set will not be able to keep duplicate objects from being added.
                    // This is why we stringify the object to be added...
                    options.add ( JSON.stringify ( { label: optionLabel, value: row.values[id] } ) );
                }
            } )
        }

        return [ ...options ].map ( ( item ) => {

            // ...and later map each of the set's entries, leaving us with a deduplicated array.
            let entry;
            if ( typeof item === 'string' ) {
                // Is it a string? Parse it as JSON to restore it.
                entry = JSON.parse ( item );
            } else if ( typeof item === 'object' ) {
                entry = item;
            }
            return entry;
        } );

    }, [ id, preFilteredRows, props.list ] );


    return <select
        className={ "select-filter" }
        value={ filterValue !== undefined ? filterValue : "" }
        onChange={ event => {
            setFilter ( event.target.value || undefined )
        } }
    >
        <option value="">All</option>
        { options.map ( ( option, i ) => (
            <option key={ i } value={ option.value }>
                { option.label }
            </option>
        ) ) }
    </select>
}


const MultiSelectFilterColumn = ( props ) =>{

    const [ values, setValues ] = useState ( [] );
    const [statusFiltered, setStatusFiltered ] = useState(['All']);

    const { column: { filterValue, preFilteredRows, setFilter, id }, } = props.info

    const options = React.useMemo ( () => {
        const options = new Set ()
        if ( props.list && props.list.length > 0 ) {
            preFilteredRows.forEach ( row => {
                const optionLabelIndex = props.list.findIndex ( ( itemInList ) => itemInList.id === row.values[id] );
                if ( optionLabelIndex !== -1 ) {
                    const optionLabel = props.list[optionLabelIndex].name
                    options.add ( JSON.stringify ( { label: optionLabel, value: row.values[id] } ) );
                }
            } )
        }

        return [ ...options ].map ( ( item ) => {

            let entry;
            if ( typeof item === 'string' ) {
                entry = JSON.parse ( item );
            } else if ( typeof item === 'object' ) {
                entry = item;
            }
            return entry;
        } );

    }, [ id, preFilteredRows, props.list ] );

    let defaultOption = {
        label: "All",
        value: "All"
    }
    options.unshift(defaultOption);
    const handleSelected = ( event ) => {
        let filteredValues,
        filteredStatuses;
        values.length > 0 ? filteredValues = values : filteredValues = [ ];
        statusFiltered.length>0 ? filteredStatuses = statusFiltered: filteredStatuses = ['All'];

        const selectedOption = options.filter((option)=> option.value === event.target.value)[0];

        if(event.target.value === "All"){
            filteredValues = options
                .map((option)=> option.value)
                .filter((item)=> item !=="All");
            filteredStatuses = options.map((option)=> option.label)
                .filter((item)=> item !=="All");
        } else if ( filteredValues.includes ( event.target.value ) === false ) {
            filteredValues = filteredValues.concat ( event.target.value );
            filteredStatuses = filteredStatuses
                .concat(selectedOption.label)
                .filter((item)=> item !=="All");
        }  else {
            filteredValues = filteredValues.filter ( ( item ) => item !== event.target.value );
            filteredStatuses = filteredStatuses
                .filter((item) => item !== selectedOption.label)
                .filter((item)=> item !=="All");
        }

        setStatusFiltered(filteredStatuses)
        props.setStatusFilters(filteredStatuses)
        setValues ( filteredValues );
        setFilter(filteredValues);
    }

    //TODO: Refactor the select into a dropdown list or something like that

    return (
        <select
                    multiple={ true}
                    value={filterValue}
                    onChange={handleSelected}
                    className={'select-filter'}
                >
            { options.map ( ( option, i ) => (
                <option key={ i } value={ option.value }>
                    { option.label }
                </option>
            ) ) }
        </select>
    )
}

const DateColumnFilter = ( { column: { setFilter } } ) => {
    const [ value, setValue ] = useState ( '' );

    function handleValue ( event ) {
        const value = event.target.value;
        setFilter ( value );
        setValue ( value );
    }

    function clearValue () {
        setFilter ( '' );
        setValue ( '' );
    }

    return (
        <InputDate
            value={ value }
            properDate={ formatDate ( value ) }
            handleChange={
                ( event ) => {
                    handleValue ( event )
                }
            }
            clearValue={ clearValue }
            required={ false }/>
    );
}

// TODO: Add a button to clear the text entry on this filter.
const fuzzyTextFilterFn = ( rows, id, filterValue ) => {
    return matchSorter ( rows, filterValue, { keys: [ row => row.values[id] ] } )
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val

const getHiddenColumnIds = ( columns ) => {
    return columns.filter ( ( item ) => item.showIn === 'expand' ).map ( item => {
        return item.id
    } )
}
const getHiddenColumnHeaders = ( columns ) => {
    return columns.filter ( ( item ) => item.showIn === 'expand' ).map ( item => {
        return { id: item.id, Header: item.Header }
    } )
}

const TicketTable = ( props ) => {
    const { columns, data, renderRowSubComponent, showTicketModal, ticketType, tableId, statusFilters, setStatusFilters } = props;

    const hiddenColumnIds = useMemo ( () => getHiddenColumnIds ( columns ), [ columns ] );
    const filterTypes = useMemo (
        () => ( {
            fuzzyText: fuzzyTextFilterFn,
            text: ( rows, id, filterValue ) => {
                return rows.filter ( row => {
                    const rowValue = row.values[id]
                    return rowValue !== undefined
                        ? String ( rowValue )
                            .toLowerCase ()
                            .startsWith ( String ( filterValue ).toLowerCase () )
                        : true
                } )
            },
            multiple: (rows, id, filterValue) => {
                return rows.filter(row => {
                    const rowValue = row.values[id];
                    return rowValue !== undefined
                        ? filterValue.includes(rowValue)
                        : true;
                });
            }
        } ),
        []
    )
    const defaultColumn = useMemo (
        () => ( {
            Filter: DefaultColumnFilter,
        } ),
        []
    )

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
        visibleColumns,
        preGlobalFilteredRows,
        setGlobalFilter,
        setFilter,
        setAllFilters,
    } = useTable ( {
            columns,
            data,
            initialState: {
                hiddenColumns: hiddenColumnIds
            },
            defaultColumn,
            filterTypes,
        },
        useFlexLayout,
        useFilters,
        useGlobalFilter,
        useSortBy,
        useExpanded )

    useEffect ( () => {
        const { id, value } = ticketType;

        setAllFilters ( [] );
        if ( id ) {
            setFilter ( id, value );
        }
    }, [ setFilter, setAllFilters, ticketType] )

    return (
        <>
            <GlobalFilter
                preGlobalFilteredRows={ preGlobalFilteredRows }
                globalFilter={ state.globalFilter }
                setGlobalFilter={ setGlobalFilter }
                statusFilters={statusFilters}

            />
            <StyledTable className={ "table-striped-alt" } hover size="sm" { ...getTableProps () } id={ tableId }>
                <TableHead>
                    {
                        headerGroups.map ( ( headerGroup, headerGroupIndex ) => (

                            <tr { ...headerGroup.getHeaderGroupProps () } key={ headerGroupIndex }>

                                {
                                    headerGroup.headers.map ( ( column, headerIndex ) => (
                                        <TableHeader className={ column.id }  { ...column.getHeaderProps () }
                                                     key={ headerIndex }>
                                            <HeaderTitle>
                                                <div className={ "title" } { ...column.getSortByToggleProps () }>
                                                    <span className={ "text" }>{ column.render ( 'Header' ) }</span>
                                                    { column.isSorted ?
                                                        column.isSortedDesc ?
                                                            <span className={ "sub" }> ▼</span>
                                                            :
                                                            <span className={ "sup" }> ▲</span>
                                                        : <span style={ {
                                                            display: "inline-block",
                                                            minWidth: "16px"
                                                        } }> </span> }
                                                </div>
                                                <div className={ column.id !=="status" ? "filter": "filter filter--status" } key={ "filter-" + headerIndex }>
                                                    { column.canFilter ? column.render ( 'Filter' ) : null }
                                                </div>
                                            </HeaderTitle>

                                        </TableHeader>
                                    ) )
                                }

                            </tr>

                        ) )
                    }
                </TableHead>
                <TableBody { ...getTableBodyProps () }>

                    {
                        rows.map ( ( row, rowIndex ) => {
                            prepareRow ( row )
                            return (
                                <React.Fragment key={ rowIndex }>
                                    <tr key={ "row-" + rowIndex }
                                        { ...row.getRowProps () }
                                        className={ "clickableRow" + ( rowIndex % 2 === 0 ? " even" : " odd" ) }
                                        onClick={ () => {
                                            showTicketModal ( row.original )
                                        } }
                                    >
                                        {
                                            row.cells.map ( ( cell, cellIndex ) => {
                                                return (
                                                    <td key={ cellIndex } { ...cell.getCellProps () }
                                                        className={ cell.column.id }>
                                                        { cell.render ( 'Cell' ) }
                                                    </td>
                                                )
                                            } )
                                        }

                                    </tr>

                                    {
                                        row.isExpanded ? (
                                                <tr className={ rowIndex % 2 === 0 ? "even" : "odd" }
                                                    key={ "exp-" + rowIndex }>
                                                    <td colSpan={ visibleColumns.length }>
                                                        <table style={ { width: "100%" } }>
                                                            <tbody>
                                                            <tr>
                                                                { renderRowSubComponent ( { row } ) }
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            )
                                            :
                                            null
                                    }

                                </React.Fragment>
                            )
                        } )
                    }

                </TableBody>
            </StyledTable>
        </>
    )
}

function TicketsSection ( props ) {

    const setFilters = props.setStatusFilters
    const [ data, setData ] = useState ( [] );
    const [ materialTypesList, setMaterialTypesList ] = useState ( [] );
    const [ salesOrgsList, setSalesOrgsList ] = useState ( [] );
    const [ ticketStatusesList, setTicketStatusesList ] = useState ( [] );
    const [ loading, setLoading ] = useState ( true );
    const [ executorTeams, setExecutorTeams ] = useState ( [] );
    const [ executorTeamMembers, setExecutorTeamMembers ] = useState ( [] );
    const [ usersInTicketList, setUsersInTicketList ] = useState ( [] );
    const [ salesOrgsInTicketList, setSalesOrgsInTicketList ] = useState ( [] );
    const [ userId, setUserId ] = useState ( [] );
    const [ userTicketingSystem, setUserTicketingSystem ] = useState ( [] );
    const [ attachmentsList, setAttachmentsList ] = useState ( [] );

    const [ defaultTicketData, setDefaultTicketData ] = useState ( [] )
    const superEditors = process.env.REACT_APP_SUPER_EDITORS.split ( " , " );

    const [ confirmationDialogOpen, setConfirmationDialogOpen ] = useState ( false );
    const [ ticketForDeletingData, setTicketForDeletingData ] = useState ( {} );

    async function fetchList ( URL ) {
        let myHeaders = new Headers ();
        myHeaders.append ( "Content-Type", "application/vnd.api+json" );
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + window.localStorage.getItem ( 'token' ) );

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return await fetch ( URL, requestOptions );
    }

    const fetchMaterialTypes = useCallback (
        async () => {
            try {
                let response = await fetchList ( BackendURL + "/jsonapi/taxonomy_term/material_type?fields[taxonomy_term--material_type]=id,name" )
                    .catch ( ( error ) => console.error ( "Error on fetchList ", error ) );
                response = await response.json ()
                    .catch ( ( error ) => console.error ( "Error on response.json ", error ) );
                return response;
            } catch ( error ) {
                console.error ( error );
            }
        },
        [],
    );

    const fetchTicketStatuses = useCallback (
        async () => {
            try {
                let response = await fetchList ( BackendURL + "/jsonapi/taxonomy_term/ticket_status?fields[taxonomy_term--material_type]=id,name" );
                response = await response.json ();
                return response;
            } catch ( error ) {
                console.error ( error );
            }
        },
        [],
    );

    const fetchSalesOrgs = useCallback (
        async () => {
            try {
                let response = await fetchList ( BackendURL + "/jsonapi/sales_org/sales_org?fields[sales_org--sales_org]=id,label" );
                response = await response.json ();
                return response;
            } catch ( error ) {
                console.error ( error );
            }
        },
        [],
    );

    const fetchExecutorsTeam = useCallback (
        async () => {
            try {
                let response = await fetchList ( BackendURL + "/jsonapi/executors_team/executors_team?include=user_id,field_executors_team_members&fields[user--user]=name" );
                response = await response.json ();
                return response;
            } catch ( error ) {
                console.error ( error );
            }
        },
        [],
    );

    const simplifyDataList = ( data, term ) => {
        if ( term === undefined ) {
            term = "name";
        }
        return data.map ( item => {
            return {
                id: item.id,
                name: item.attributes[term]
            }
        } )
    }


    useEffect ( () => {
        setUserId ( props.userUUID );
        setUserTicketingSystem ( props.ticketingUUID );


        fetchMaterialTypes ()
            .then ( result => {
                const materialTypesList = simplifyDataList ( result.data )
                setMaterialTypesList ( materialTypesList );
                setDefaultTicketData (
                    ( prevState => {
                        return {
                            ...prevState,
                            materialType: materialTypesList[0].id
                        }
                    } )
                )
            } )
            .catch ( error => console.error ( 'error fetching material types ', error ) )

        fetchTicketStatuses ()
            .then ( result => {
                const statusesList = simplifyDataList ( result.data );
                setTicketStatusesList ( statusesList );
                setDefaultTicketData (
                    ( prevState => {
                        return {
                            ...prevState,
                            status: statusesList[0].id
                        }
                    } )
                )
            } )
            .catch ( error => console.error ( 'error fetching ticket statuses ', error ) )

        fetchSalesOrgs ()
            .then ( result => {
                setSalesOrgsList ( simplifyDataList ( result.data, "label" ) );
            } )
            .catch ( error => console.error ( 'error fetching ticket statuses ', error ) )

        fetchExecutorsTeam ()
            .then ( result => {
                const executor_team_members = result.included
                    .filter ( team_member => team_member.attributes.name && team_member.attributes.name !== "admin")
                    .map ( team_member => ( {
                            id: team_member.id,
                            name: team_member.attributes.name
                        } )
                    )

                const executor_teams = result.data
                    .map ( team => ( {
                            id: team.id,
                            name: team.attributes.name,
                            members: team.relationships.field_executors_team_members.data
                                .filter( item => item.id !=="missing" )
                                .map ( team_member => ( {
                                        id: team_member.id,
                                        name: executor_team_members
                                            .find ( item => item.id === team_member.id ).name
                                    } )
                                )
                        } )
                    )
                setExecutorTeams ( executor_teams )
                setExecutorTeamMembers ( executor_team_members )
            } )
            .catch ( error => console.error ( 'error fetching executor team data', error ) )
    }, [ fetchExecutorsTeam, fetchMaterialTypes, fetchSalesOrgs, fetchTicketStatuses, userId, userTicketingSystem, props.ticketingUUID, props.userUUID ] )

    useEffect ( () => {

        if ( userId &&
            userTicketingSystem &&
            ticketStatusesList.length > 0 &&
            salesOrgsList.length > 0 &&
            executorTeams.length > 0 &&
            executorTeamMembers.length > 0 &&
            ( ( usersInTicketList.length > 0 && data.length > 0 ) || ( usersInTicketList.length === 0 && data.length === 0 ) )
        ) {
            setLoading ( false )

        }


        // if ( userId &&
        //     userTicketingSystem &&
        //     ticketStatusesList.length > 0 &&
        //     salesOrgsList.length > 0 &&
        //     executorTeams.length > 0 &&
        //     executorTeamMembers.length > 0 &&
        //     usersInTicketList.length > 0 ) {
        //     setLoading( false )
        // } else if ( userId &&
        //             userTicketingSystem &&
        //             !!!props.teamUUID &&
        //             usersInTicketList.length === 0 &&
        //             salesOrgsInTicketList.length === 0
        //             && attachmentsList.length === 0 ){
        //     setLoading(false);
        // }
    }, [ userId, userTicketingSystem, materialTypesList, ticketStatusesList, salesOrgsList, executorTeams, executorTeamMembers, data, usersInTicketList, salesOrgsInTicketList, attachmentsList, props.teamUUID ] )

    useEffect ( () => {
        async function fetchTicketsList ( ticketingUUID, isExecutor, userUUID ) {
            const query = "/jsonapi/ticket/ticket?include=field_ticket_assignee,field_ticket_requester,field_ticket_sales_org,field_ticket_ticketing_system,field_ticket_attachments"
            const ticketSystemFilter = "&filter[ticket_system_filter][condition][path]=field_ticket_ticketing_system.id&filter[ticket_system_filter][condition][operator]=%3D&filter[ticket_system_filter][condition][value]=" + ticketingUUID;
            const userFilter = "&filter[user_filter][condition][path]=field_ticket_requester.id&filter[user_filter][condition][operator]=%3D&filter[user_filter][condition][value]=" + userUUID;
            const sorting = "&sort=-created"

            let ticketListQuery = query + ticketSystemFilter;
            if ( !isExecutor ) {
                ticketListQuery += userFilter;
            }

            // @TODO Refactor not to use the maximum in the limit, the use of pager should be implemented.
            let response = await fetchList ( BackendURL + ticketListQuery + sorting + '&page[limit]=500' );
            response = await response.json ();
            return response
        }

        fetchTicketsList ( userTicketingSystem, !!props.teamUUID, props.userUUID )
            .then ( result => {
                /* Extract and normalize the tickets on ticket list */
                if ( result.data ) {
                    if ( result.data.length > 0 ) {
                        const ticketList = result.data.map ( item => {
                            return {
                                id: item.attributes.drupal_internal__id,
                                subject: item.attributes.summary,
                                materialType: item.relationships.field_ticket_material_type.data.id,
                                status: item.relationships.field_ticket_status.data === null ? "0" : item.relationships.field_ticket_status.data.id,
                                executorTeam: item.relationships.field_ticket_executors_team.data === null ? "0" : item.relationships.field_ticket_executors_team.data.id,
                                requestedDate: item.attributes.field_ticket_requested_date,//item.attributes.created.substr( 0, 10 ),
                                necessityDate: item.attributes.field_ticket_date_needed_by,
                                dueDate: item.attributes.field_ticket_due_date,
                                jobTitle: item.attributes.field_ticket_job_position,
                                originalRequester: item.attributes.field_ticket_original_requester ===null ? "" : item.attributes.field_ticket_original_requester,
                                resource: item.attributes.field_ticket_resource,
                                attachments: item.relationships.field_ticket_attachments.data,
                                description: item.attributes.field_ticket_description,
                                author: item.relationships.field_ticket_requester.data.id,
                                salesOrg: item.relationships.field_ticket_sales_org.data.id,
                                assigned: item.relationships.field_ticket_assignee.data === null ? "0" : item.relationships.field_ticket_assignee.data.id,
                                resolution: item.attributes.field_ticket_resolution,
                                responsible: "",
                                uuid: item.id
                            }
                        } )
                        setData ( ticketList );
                    } else {
                        setData ( [] );
                    }
                }


                /* Extract and normalize the users in the ticket list */
                if ( result.included ) {
                    // console.info(result.included)
                    const usersFromQuery = result.included
                        .filter ( item => item.type === "user--user")
                        .map ( user => ( {
                            id: user.id,
                            name: user.attributes.name ?? user.attributes.display_name,
                            display_name: user.attributes.display_name
                        } ) );
                    setUsersInTicketList ( usersFromQuery );

                    /* Extract and normalize the sales orgs in the ticket list */
                    const salesOrgsFromQuery = result.included
                        .filter ( item => item.type === "sales_org--sales_org" )
                        .map ( user => ( {
                            id: user.id,
                            name: user.attributes.label.replace ( 'Werfen ', '' )
                        } ) );
                    setSalesOrgsInTicketList ( salesOrgsFromQuery );

                    /* Extract and normalize the attached files in the ticket list */
                    const attachmentsOnTicketList = result.included
                        .filter ( item => item.type === "file--file" )
                        .map ( file => ( {
                            id: file.id,
                            filename: file.attributes.filename,
                            url: file.attributes.uri.url
                        } ) );
                    setAttachmentsList ( attachmentsOnTicketList );
                } else {
                    // console.info("no included")
                    setUsersInTicketList ( [] );
                    setSalesOrgsInTicketList ( [] );
                    setAttachmentsList ( [] )
                }
            } )
            .catch ( error => console.error ( 'error fetching tickets', error ) )
    }, [ props.ticketList, props.userUUID, props.teamUUID, userTicketingSystem ] );

    const tableData = useMemo ( () => data, [ data ] );

    const handleDeleteTicket = ( ticketId ) => {
        const deleteTicketUrl = process.env.REACT_APP_BACKEND_MACHINE;
        let myHeaders = new Headers ();
        myHeaders.append ( "Content-Type", "application/vnd.api+json" );
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + window.localStorage.getItem ( "token" ) );

        let raw = "";

        let requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch ( `${ deleteTicketUrl }/jsonapi/ticket/ticket/${ ticketId }`, requestOptions )
            .then ( response => response.status )
            .then ( result => console.log ( { responseStatus: result } ) )
            .catch ( error => console.log ( 'error', error ) );

        setTicketForDeletingData ( {} )
        props.removeTicketFromList ( ticketId );
        setConfirmationDialogOpen ( false );
    }
    const handleCloseDialog = () => {
        setTicketForDeletingData ( {} );
        setConfirmationDialogOpen ( false );
    }

    let messageArray = [];
    const ticketDeleteConfirmationQuestion =
        <span>Do you really want to delete the ticket number <strong
            style={ { color: '#001387' } }>{ ticketForDeletingData.id } </strong> with the subject of <strong
            style={ { color: '#001387' } }>{ ticketForDeletingData.subject }</strong> ?</span>;
    const ticketDeleteConfirmAction =
        <span>Please confirm that you want to delete the selected ticket by clicking on the <strong
            style={ { color: '#E86D2A' } }>Yes</strong> button.</span>;
    const ticketDeleteCancelAction =
        <span>Or cancel either by closing the modal or clicking on the <strong
            style={ { color: '#001387' } }>No</strong> button.</span>

    if ( ticketForDeletingData.hasOwnProperty ( 'uuid' ) ) {
        messageArray = [
            ticketDeleteConfirmationQuestion,
            'This action can not be undone.',
            ticketDeleteConfirmAction,
            ticketDeleteCancelAction
        ];
    }
    const executorColumns = useMemo ( () => [ {
        Header: 'Id',
        accessor: 'id',
        id: 'id',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        canFilter: false,
        disableFilters: true, // minWidth: 50,
        // maxWidth: 50,
        width: 30,
    }, {
        Header: 'Subject',
        accessor: 'subject',
        id: 'subject',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        minWidth: 200
    }, {
        Header: 'Material Type',
        accessor: 'materialType',
        id: 'materialType',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            const materialIndex = materialTypesList.findIndex ( ( material ) => material.id === item.value )
            return materialTypesList && materialTypesList[materialIndex] ? materialTypesList[materialIndex].name : "N/A"
        },
        Filter: ( props ) => {
            const obj = {
                info: props, list: materialTypesList
            }
            return SelectKVFilter ( obj )
        },
        filter: 'includes',
        maxWidth: 70
    }, {
        Header: 'Status',
        accessor: 'status',
        id: 'status',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            // const statusIndex = ticketStatusesList.findIndex( ( status ) => status.id === item.value )
            // return ticketStatusesList[statusIndex].name
            const tickStatList = ticketStatusesList.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
            const statusIndex = tickStatList.findIndex ( ( status ) => status.id === item.value ); // TODO: REMOVE
            return tickStatList && tickStatList[statusIndex] ? tickStatList[statusIndex].name : "N/A"; // TODO: REMOVE
        },
        Filter: ( props ) => {

            const obj = {
                info: props, // list: ticketStatusesList,
                list: ticketStatusesList.concat ( { id: "0", name: "TBD" } ) ,// TODO: REMOVE
                setStatusFilters: setFilters
            }
            return MultiSelectFilterColumn ( obj )
        },
        filter: 'multiple',
        width: 70,
    }, {
        Header: 'Creation Date',
        accessor: 'requestedDate',
        id: 'requestedDate',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            return formatDate ( item.row.original.requestedDate )
        },
        Filter: DateColumnFilter,
        maxWidth: 70
    }, {
        Header: 'Necessity Date',
        accessor: 'necessityDate',
        id: 'necessityDate',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            return formatDate ( item.row.original.necessityDate )
        },
        Filter: DateColumnFilter,
        maxWidth: 70
    }, {
        Header: 'Due Date',
        accessor: 'dueDate',
        id: 'dueDate',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            return formatDate ( item.row.original.dueDate )
        },
        Filter: DateColumnFilter,
        maxWidth: 70
    }, {
        Header: 'Job Text', accessor: 'jobTitle', id: 'jobTitle', useIn: [ 'executor' ], showIn: 'expand'
    }, {
        Header: 'Original Requester', accessor: 'originalRequester', id: 'originalRequester', useIn: [ 'executor' ], showIn: 'expand'
    },{
        Header: 'Author', accessor: 'author', id: 'author', useIn: [ 'executor' ], showIn: 'main', Cell: ( item ) => {
            const userIndex = usersInTicketList.findIndex ( ( user ) => user.id === item.value )
            const validatedIndex = userIndex >= 0 ? userIndex : 0
            return ( usersInTicketList && usersInTicketList[validatedIndex] ) ? usersInTicketList[validatedIndex].name : "N/A"
        }, Filter: ( props ) => {
            const obj = {
                info: props, list: usersInTicketList
            }
            return SelectKVFilter ( obj )
        }, maxWidth: 70
    }, {
        Header: 'Sales Org',
        accessor: 'salesOrg',
        id: 'salesOrg',
        useIn: [ 'executor' ],
        showIn: 'main',
        Cell: ( item ) => {
            const salesOrgIndex = salesOrgsInTicketList.findIndex ( ( salesOrg ) => salesOrg.id === item.value )
            return salesOrgsInTicketList && salesOrgsInTicketList[salesOrgIndex] ? salesOrgsInTicketList[salesOrgIndex].name : "N/A"
        },
        Filter: ( props ) => {
            const obj = {
                info: props, list: salesOrgsInTicketList
            }
            return SelectKVFilter ( obj )
        },
        filter: 'includes',
        maxWidth: 70
    }, {
        Header: 'Assigned To',
        accessor: 'assigned',
        id: 'assigned',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            // const executorTeamMemberIndex = executorTeamMembers.findIndex( ( team ) => team.id === item.value )
            // return executorTeamMembers[executorTeamMemberIndex].name
            const execTeamMembers = executorTeamMembers.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
            const executorTeamMemberIndex = execTeamMembers.findIndex ( ( team ) => team.id === item.value ) // TODO: REMOVE
            return execTeamMembers && execTeamMembers[executorTeamMemberIndex] ? execTeamMembers[executorTeamMemberIndex].name : "N/A";  // TODO: REMOVE
            // return ""
        },
        Filter: ( props ) => {
            const obj = {
                info: props, // list: executorTeamMembers,
                list: executorTeamMembers.concat ( { id: "0", name: "TBD" } )
            }
            return SelectKVFilter ( obj )
        },
        filter: 'includes',
        maxWidth: 70
    }, {
        Header: 'Description',
        accessor: 'description',
        id: 'description',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'expand',
        Cell: ( { row } ) => {
            const output = row.original.description.replace ( /\n/g, "<br />" )
            return ( <div className={ "clamp-15" }>{ output }</div> )
        }
    }, {
        Header: 'Response', accessor: 'response', id: 'response', useIn: [ 'executor', 'petitioner' ], showIn: 'expand'
    }, {
        Header: 'Download Delivery', accessor: 'resource', id: 'resource', useIn: [ 'executor', 'petitioner' ], showIn: 'expand',
    }, {
        Header: 'Responsible',
        accessor: 'responsible',
        id: 'responsible',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'expand',
        disableSortBy: true
    }, {
        Header: ( { getToggleAllRowsExpandedProps, isAllRowsExpanded } ) => (
            <span { ...getToggleAllRowsExpandedProps () }>
                        <FeatherIconWrapper
                            color={ WerfenColor }
                            fillColor={ "none" }
                            width={ "30px" }
                            Icon={ !isAllRowsExpanded ? SquarePlusIcon : SquareMinusIcon }/>
                </span>
        ),
        id: 'expander',
        disableSortBy: true,
        width: 40,
        Cell: ( { row } ) => {
            return (
                <span { ...row.getToggleRowExpandedProps () }
                      onClick={ ( event ) => {
                          event.stopPropagation ();
                          row.toggleRowExpanded ();
                      } }
                      className={ "expander__icon" }>
                <FeatherIconWrapper
                    color={ WerfenColor }
                    fillColor={ "none" }
                    width={ "30px" }
                    Icon={ !row.isExpanded ? SquarePlusIcon : SquareMinusIcon }/>
                </span>
            )
        },
    },
    ], [ loading, data, materialTypesList, ticketStatusesList, salesOrgsList, executorTeams, executorTeamMembers, usersInTicketList, salesOrgsInTicketList, attachmentsList ] )// eslint-disable-line react-hooks/exhaustive-deps
    const superEditorsColumns = useMemo ( () => [ {
        Header: 'Id',
        accessor: 'id',
        id: 'id',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        canFilter: false,
        disableFilters: true, // minWidth: 50,
        // maxWidth: 50,
        width: 30,
    }, {
        Header: 'Subject',
        accessor: 'subject',
        id: 'subject',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        minWidth: 200
    }, {
        Header: 'Material Type',
        accessor: 'materialType',
        id: 'materialType',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            const materialIndex = materialTypesList.findIndex ( ( material ) => material.id === item.value )
            return materialTypesList && materialTypesList[materialIndex] ? materialTypesList[materialIndex].name : "N/A"
        },
        Filter: ( props ) => {
            const obj = {
                info: props, list: materialTypesList
            }
            return SelectKVFilter ( obj )
        },
        filter: 'includes',
        maxWidth: 70
    }, {
        Header: 'Status',
        accessor: 'status',
        id: 'status',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            // const statusIndex = ticketStatusesList.findIndex( ( status ) => status.id === item.value )
            // return ticketStatusesList[statusIndex].name
            const tickStatList = ticketStatusesList.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
            const statusIndex = tickStatList.findIndex ( ( status ) => status.id === item.value ); // TODO: REMOVE
            return tickStatList && tickStatList[statusIndex] ? tickStatList[statusIndex].name : "N/A"; // TODO: REMOVE
        },
        Filter: ( props ) => {
            const obj = {
                info: props, // list: ticketStatusesList,
                list: ticketStatusesList.concat ( { id: "0", name: "TBD" } ),
                setStatusFilters: setFilters// TODO: REMOVE
            }
            return MultiSelectFilterColumn ( obj )
        },
        filter: 'multiple',
        width: 70,
    }, {
        Header: 'Creation Date',
        accessor: 'requestedDate',
        id: 'requestedDate',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            return formatDate ( item.row.original.requestedDate )
        },
        Filter: DateColumnFilter,
        maxWidth: 70
    }, {
        Header: 'Necessity Date',
        accessor: 'necessityDate',
        id: 'necessityDate',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            return formatDate ( item.row.original.necessityDate )
        },
        Filter: DateColumnFilter,
        maxWidth: 70
    }, {
        Header: 'Due Date',
        accessor: 'dueDate',
        id: 'dueDate',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            return formatDate ( item.row.original.dueDate )
        },
        Filter: DateColumnFilter,
        maxWidth: 70
    }, {
        Header: 'Job Text', accessor: 'jobTitle', id: 'jobTitle', useIn: [ 'executor' ], showIn: 'expand'
    }, {
        Header: 'Original Requester', accessor: 'originalRequester', id: 'originalRequester', useIn: [ 'executor' ], showIn: 'expand'
    },{
        Header: 'Author', accessor: 'author', id: 'author', useIn: [ 'executor' ], showIn: 'main', Cell: ( item ) => {
            const userIndex = usersInTicketList.findIndex ( ( user ) => user.id === item.value )
            const validatedIndex = userIndex >= 0 ? userIndex : 0
            return ( usersInTicketList && usersInTicketList[validatedIndex] ) ? usersInTicketList[validatedIndex].name : "N/A"
        }, Filter: ( props ) => {
            const obj = {
                info: props, list: usersInTicketList
            }
            return SelectKVFilter ( obj )
        }, maxWidth: 70
    }, {
        Header: 'Sales Org',
        accessor: 'salesOrg',
        id: 'salesOrg',
        useIn: [ 'executor' ],
        showIn: 'main',
        Cell: ( item ) => {
            const salesOrgIndex = salesOrgsInTicketList.findIndex ( ( salesOrg ) => salesOrg.id === item.value )
            return salesOrgsInTicketList && salesOrgsInTicketList[salesOrgIndex] ? salesOrgsInTicketList[salesOrgIndex].name : "N/A"
        },
        Filter: ( props ) => {
            const obj = {
                info: props, list: salesOrgsInTicketList
            }
            return SelectKVFilter ( obj )
        },
        filter: 'includes',
        maxWidth: 70
    }, {
        Header: 'Assigned To',
        accessor: 'assigned',
        id: 'assigned',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'main',
        Cell: ( item ) => {
            // const executorTeamMemberIndex = executorTeamMembers.findIndex( ( team ) => team.id === item.value )
            // return executorTeamMembers[executorTeamMemberIndex].name
            const execTeamMembers = executorTeamMembers.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
            const executorTeamMemberIndex = execTeamMembers.findIndex ( ( team ) => team.id === item.value ) // TODO: REMOVE
            return execTeamMembers && execTeamMembers[executorTeamMemberIndex] ? execTeamMembers[executorTeamMemberIndex].name : "N/A";  // TODO: REMOVE
            // return ""
        },
        Filter: ( props ) => {
            const obj = {
                info: props, // list: executorTeamMembers,
                list: executorTeamMembers.concat ( { id: "0", name: "TBD" } )
            }
            return SelectKVFilter ( obj )
        },
        filter: 'includes',
        maxWidth: 70
    }, {
        Header: 'Description',
        accessor: 'description',
        id: 'description',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'expand',
        Cell: ( { row } ) => {
            const output = row.original.description.replace ( /\n/g, "<br />" )
            return ( <div className={ "clamp-15" }>{ output }</div> )
        }
    }, {
        Header: 'Response', accessor: 'response', id: 'response', useIn: [ 'executor', 'petitioner' ], showIn: 'expand'
    }, {
        Header: 'Download Delivery',
        accessor: 'resource',
        id: 'resource',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'expand'
    }, {
        Header: 'Responsible',
        accessor: 'responsible',
        id: 'responsible',
        useIn: [ 'executor', 'petitioner' ],
        showIn: 'expand',
        disableSortBy: true
    }, {
        Header: ( { getToggleAllRowsExpandedProps, isAllRowsExpanded } ) => (
            <span { ...getToggleAllRowsExpandedProps () }>
                        <FeatherIconWrapper
                            color={ WerfenColor }
                            fillColor={ "none" }
                            width={ "30px" }
                            Icon={ !isAllRowsExpanded ? SquarePlusIcon : SquareMinusIcon }/>
                </span>
        ),
        id: 'expander',
        disableSortBy: true,
        width: 40,
        Cell: ( { row } ) => {
            return (
                <span { ...row.getToggleRowExpandedProps () }
                      onClick={ ( event ) => {
                          event.stopPropagation ();
                          row.toggleRowExpanded ();
                      } }
                      className={ "expander__icon" }>
                <FeatherIconWrapper
                    color={ WerfenColor }
                    fillColor={ "none" }
                    width={ "30px" }
                    Icon={ !row.isExpanded ? SquarePlusIcon : SquareMinusIcon }/>
                </span>
            )
        },
    },
        {
            Header: ( {} ) => ( <span>

                </span> ), id: 'deleter', disableSortBy: true, width: 40,
            Cell: ( { row } ) => {
                return ( <span
                    onClick={ ( event ) => {
                        event.stopPropagation ();
                        if ( confirmationDialogOpen === false ) {
                            setConfirmationDialogOpen ( true );
                            setTicketForDeletingData ( row.original )
                        }
                    } }
                    role={ 'button' }
                    disabled={ confirmationDialogOpen === false }
                    className={ "expander__icon" }>
                <FeatherIconWrapper
                    color={ WerfenColor }
                    fillColor={ "none" }
                    width={ "30px" }
                    Icon={ DeleteIcon }/>
                </span> )
            }
        }
    ], [ loading, data, materialTypesList, ticketStatusesList, salesOrgsList, executorTeams, executorTeamMembers, usersInTicketList, salesOrgsInTicketList, attachmentsList ] )// eslint-disable-line react-hooks/exhaustive-deps

    const requesterColumns = useMemo ( () => [
        {
            Header: 'Id',
            accessor: 'id',
            id: 'id',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            canFilter: false,
            disableFilters: true, // minWidth: 50,
            // maxWidth: 50,
            width: 30,
        },
        {
            Header: 'Subject',
            accessor: 'subject',
            id: 'subject',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            minWidth: 200
        },
        {
            Header: 'Material Type',
            accessor: 'materialType',
            id: 'materialType',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                const materialIndex = materialTypesList.findIndex ( ( material ) => material.id === item.value )
                return materialTypesList && materialTypesList[materialIndex] ? materialTypesList[materialIndex].name : "N/A"
            },
            Filter: ( props ) => {
                const obj = {
                    info: props, list: materialTypesList
                }
                return SelectKVFilter ( obj )
            },
            filter: 'includes',
            maxWidth: 70
        },
        {
            Header: 'Team',
            accessor: 'executorTeam',
            id: 'executorTeam',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                // const executorTeamIndex = executorTeams.findIndex( ( team ) => team.id === item.value )
                // return executorTeams[executorTeamIndex].name
                const execTeams = executorTeams.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
                const executorTeamIndex = execTeams.findIndex ( ( team ) => team.id === item.value ); // TODO: REMOVE
                return execTeams && execTeams[executorTeamIndex] ? execTeams[executorTeamIndex].name : "N/A"; // TODO: REMOVE

            },
            Filter: ( props ) => {
                const obj = {
                    info: props, // list: executorTeams,
                    list: executorTeams.concat ( { id: "0", name: "TBD" } ) // TODO: REMOVE
                }
                return SelectKVFilter ( obj )
            },
            filter: 'includes',
            maxWidth: 100
        },
        {
            Header: 'Status',
            accessor: 'status',
            id: 'status',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                // const statusIndex = ticketStatusesList.findIndex( ( status ) => status.id === item.value )
                // return ticketStatusesList[statusIndex].name
                // const tickStatList = ticketStatusesList.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
                const statusIndex = ticketStatusesList.findIndex ( ( status ) => status.id === item.value ); // TODO: REMOVE
                return ticketStatusesList && ticketStatusesList[statusIndex] ? ticketStatusesList[statusIndex].name : "N/A"; // TODO: REMOVE
            },
            Filter: ( props ) => {
                const obj = {
                    info: props, // list: ticketStatusesList,
                    list: ticketStatusesList.concat ( { id: "0", name: "TBD" } ) // TODO: REMOVE
                }
                return MultiSelectFilterColumn ( obj )
            },
            filter: 'multiple',
            width: 70,
        },
        {
            Header: 'Author',
            accessor: 'author',
            id: 'author',
            useIn: [ 'executor' ],
            showIn: 'main',
            Cell: ( item ) => {
                const userIndex = usersInTicketList.findIndex ( ( user ) => user.id === item.value )
                const validatedIndex = userIndex >= 0 ? userIndex : 0
                return ( usersInTicketList && usersInTicketList[validatedIndex] ) ? usersInTicketList[validatedIndex].name : "N/A"
            },
            Filter: ( props ) => {
                const obj = {
                    info: props, list: usersInTicketList
                }
                return SelectKVFilter ( obj )
            },
            maxWidth: 70
        },
        {
            Header: 'Creation Date',
            accessor: 'requestedDate',
            id: 'requestedDate',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                return formatDate ( item.row.original.requestedDate )
            },
            Filter: DateColumnFilter,
            maxWidth: 70
        },
        {
            Header: 'Necessity Date',
            accessor: 'necessityDate',
            id: 'necessityDate',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                return formatDate ( item.row.original.necessityDate )
            },
            Filter: DateColumnFilter,
            maxWidth: 70
        },
        {
            Header: 'Due Date',
            accessor: 'dueDate',
            id: 'dueDate',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                return formatDate ( item.row.original.dueDate )
            },
            Filter: DateColumnFilter,
            maxWidth: 70
        },
        {
            Header: 'Assigned To',
            accessor: 'assigned',
            id: 'assigned',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'main',
            Cell: ( item ) => {
                // const executorTeamMemberIndex = executorTeamMembers.findIndex( ( team ) => team.id === item.value )
                // return executorTeamMembers[executorTeamMemberIndex].name
                const execTeamMembers = executorTeamMembers.concat ( { id: "0", name: "TBD" } ); // TODO: REMOVE
                const executorTeamMemberIndex = execTeamMembers.findIndex ( ( team ) => team.id === item.value ) // TODO: REMOVE
                const validatedIndex = executorTeamMemberIndex >= 0 ? executorTeamMemberIndex : 0
                return execTeamMembers && execTeamMembers[validatedIndex] ? execTeamMembers[validatedIndex].name : "N/A";  // TODO: REMOVE
                // return ""
            },
            Filter: ( props ) => {
                const obj = {
                    info: props, // list: executorTeamMembers,
                    list: executorTeamMembers.concat ( { id: "0", name: "TBD" } )
                }
                return SelectKVFilter ( obj )
            },
            filter: 'includes',
            maxWidth: 70
        },
        {
            Header: 'Description',
            accessor: 'description',
            id: 'description',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'expand',
            Cell: ( { row } ) => {
                const output = row.original.description.replace ( /\n/g, "<br />" )
                return ( <div className={ "clamp-15" }>{ output }</div> )
            }
        },
        {
            Header: 'Response',
            accessor: 'response',
            id: 'response',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'expand'
        },
        {
            Header: 'Download Delivery',
            accessor: 'resource',
            id: 'resource',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'expand'
        },
        {
            Header: 'Responsible',
            accessor: 'responsible',
            id: 'responsible',
            useIn: [ 'executor', 'petitioner' ],
            showIn: 'expand',
            disableSortBy: true
        },
        {
            Header: ( { getToggleAllRowsExpandedProps, isAllRowsExpanded } ) => (
                <span { ...getToggleAllRowsExpandedProps () }>
                        <FeatherIconWrapper
                            color={ WerfenColor }
                            fillColor={ "none" }
                            width={ "30px" }
                            Icon={ !isAllRowsExpanded ? SquarePlusIcon : SquareMinusIcon }/>
                </span>
            ),
            id: 'expander',
            disableSortBy: true,
            width: 40,
            Cell: ( { row } ) => {
                return (
                    <span { ...row.getToggleRowExpandedProps () }
                          onClick={ ( event ) => {
                              event.stopPropagation ();
                              row.toggleRowExpanded ();
                          } }
                          className={ "expander__icon" }>
                <FeatherIconWrapper
                    color={ WerfenColor }
                    fillColor={ "none" }
                    width={ "30px" }
                    Icon={ !row.isExpanded ? SquarePlusIcon : SquareMinusIcon }/>
                </span>
                )
            },
        },

    ], [ loading, data, materialTypesList, ticketStatusesList, salesOrgsList, executorTeams, executorTeamMembers, usersInTicketList, salesOrgsInTicketList, attachmentsList ] )// eslint-disable-line react-hooks/exhaustive-deps

    let columns = requesterColumns;
    let tableId = "requesterTable";
   /* if ( props.teamUUID && props.canExecute ) {
        columns = executorColumns;
        tableId = "executorTable"
    }*/
    // TODO: Add here props.canDelete permissions when it will be ready in Drupal
    if ( props.teamUUID && props.canExecute ) {
        columns = superEditorsColumns;
        tableId = "superEditorTable"
    }


    const hiddenColumns = useMemo ( () => getHiddenColumnHeaders ( columns ), [ columns ] );

    const renderRowSubComponent = React.useCallback (
        ( { row } ) => {
            return hiddenColumns.map ( ( item, hIndex ) => {
                return <td key={ hIndex } style={ { padding: "0 8px", verticalAlign: "top" } }>
                    {(item.id !=="resource") && <div className={ "hiddenColumn hiddenColumn-" + item.id }>
                        <div>
                            <b>{ item.Header }</b>
                        </div>
                        <div className={ item.id === "description" ? "clamp-15" : "" }>
                            <span>{ row.values[item.id] }</span>
                        </div>
                    </div>}
                    {(item.id ==="resource") && <div className={ "hiddenColumn hiddenColumn-" + item.id }>
                        <div>
                            <b>{ item.Header }</b>
                        </div>
                         <a href={row.values[item.id]} >{row.values[item.id]}</a>
                    </div>}
                </td>
            } )
        },
        [ hiddenColumns ]
    )

    return (
        <StyledDiv>
            <WrapperDiv>
                <Title>Tickets</Title>
                { loading && <Loader message="Getting tickets" primaryColor={ WerfenColor }
                                     secondaryColor={ Shadow }
                                     fontColor={ Black }/> }
                { !loading && props.teamUUID && <TicketActions
                    setTicketType={ props.setTicketType }
                    showTicketModal={ props.showTicketModal }
                    defaultTicketData={ defaultTicketData }
                /> }
                { !loading && !props.teamUUID && <TicketForm/> }

                { !loading && tableData.length > 0 && <TicketTable
                    ticketType={ props.ticketType }
                    columns={ columns }
                    data={ tableData }
                    showTicketModal={ props.showTicketModal }
                    teamUUID={ props.teamUUID }
                    renderRowSubComponent={ renderRowSubComponent }
                    tableId={ tableId }
                    statusFilters={props.statusFilters}
                    setStatusFilters={props.setStatusFilters}
                /> }
                { !loading && tableData.length === 0 && <div>No tickets yet</div> }
            </WrapperDiv>
            <TicketModal
                orders={ true }
                materialTypesList={ materialTypesList }
                ticketStatusesList={ ticketStatusesList }
                salesOrgsList={ salesOrgsList }
                executorTeams={ executorTeams }
                executorTeamMembers={ executorTeamMembers }
                usersInTicketList={ usersInTicketList }
                userTicketingSystem={ userTicketingSystem }
                attachmentsList={ attachmentsList }
                setLoading={ setLoading }
                defaultTicketData={ defaultTicketData }
            />
            < ConfirmationDialog
                show={ confirmationDialogOpen }
                onHide={ handleCloseDialog }
                title={ "Delete Ticket Confirmation Dialog" }
                messageArray={ messageArray }
                handleOnCancel={ handleCloseDialog }
                handleOnAccept={ () => handleDeleteTicket ( ticketForDeletingData.uuid ) }
                labelCancel={ "No" }
                labelAccept={ "Yes" }
            />
        </StyledDiv> )
}

function mapStateToProps ( state ) {
    return {
        ticketData: state.tickets.ticketData,
        ticketType: state.tickets.ticketType,
        ticketList: state.tickets.ticketList,
        statusFilters: state.tickets.statusFilters,
        userUUID: state.session.userUUID,
        ticketingUUID: state.session.ticketingUUID,
        teamUUID: state.session.teamUUID,
        canExecute: state.session.canExecute,
        canDelete: state.session.canDelete,
        username: state.session.user,
    };
}

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        showTicketModal: showTicketModal,
        removeTicketFromList: removeTicketFromList,
        setTicketType: setTicketType,
        setTicketList: setTicketList,
        setStatusFilters: setStatusFilters
    }, dispatch );
};

export default connect (
    mapStateToProps, mapDispatchToProps
) ( TicketsSection );
